import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Datepicker from "vuejs-datepicker";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import JobSelectVehicle from "@/components/optimization/jobs/JobSelectVehicle.vue";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import JobAssignedVisitPointPickup from "@/components/optimization/jobs/JobAssignedVisitPointPickup.vue";
import JobAssignedVisitPointDelivery from "@/components/optimization/jobs/JobAssignedVisitPointDelivery.vue";
const KEY_BACKSPACE = "Backspace";
const KEY_ENTER = "Enter";
const KEY_TAB = "Tab";

export const jobCreateMixin = {
	name: "JobCreate",
	components: {
		vSelect,
		flatPickr,
		Datepicker,
		VuePerfectScrollbar,
		JobSelectVehicle,
		JobAssignedVisitPointPickup,
		JobAssignedVisitPointDelivery,
	},
	data() {
		return {
			activeTabJob: 0,
			selectedJob: [],
			propertiesListCostPerVehicles: [],
			showPromptCostPerVehicles: false,
			propertyCostPerVehicles: "",
			absoluteDetourLimit: {
				hours: 0,
				minutes: 0,
				seconds: 0,
			},
			timeLimit: {
				hours: 0,
				minutes: 0,
				seconds: 0,
			},
			settingsForm: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			job: {
				name: "",
				cost_per_vehicles: [],
				ignore: false,
				penalty_cost: 0,
				pickup_to_delivery_absolute_detour_limit: "",
				pickup_to_delivery_time_limit: "",
				pickup_to_delivery_relative_detour_limit: 0,
			},
		};
	},
	watch: {
		"absoluteDetourLimit.minutes"(val) {
			if (val > 59) {
				this.absoluteDetourLimit.minutes = 59;
			} else if (val === "00") {
				this.absoluteDetourLimit.minutes = 0;
			} else if (val === "0" || val === null || val === "") {
				this.absoluteDetourLimit.minutes = val;
			} else if (val.length > 1) {
				this.absoluteDetourLimit.minutes = val.replace(/^0+/, "");
			}
		},
		"absoluteDetourLimit.seconds"(val) {
			if (val > 59) {
				this.absoluteDetourLimit.seconds = 59;
			} else if (val === "00") {
				this.absoluteDetourLimit.seconds = 0;
			} else if (val === "0" || val === null || val === "") {
				this.absoluteDetourLimit.seconds = val;
			} else if (val.length > 1) {
				this.absoluteDetourLimit.seconds = val.replace(/^0+/, "");
			}
		},
		"absoluteDetourLimit.hours"(val) {
			if (val === "00") {
				this.absoluteDetourLimit.hours = 0;
			} else if (val === "0" || val === null || val === "") {
				this.absoluteDetourLimit.hours = val;
			} else if (val.length > 1) {
				this.absoluteDetourLimit.hours = val.replace(/^0+/, "");
			}
		},
		"timeLimit.minutes"(val) {
			if (val > 59) {
				this.timeLimit.minutes = 59;
			} else if (val === "00") {
				this.timeLimit.minutes = 0;
			} else if (val === "0" || val === null || val === "") {
				this.timeLimit.minutes = val;
			} else if (val.length > 1) {
				this.timeLimit.minutes = val.replace(/^0+/, "");
			}
		},
		"timeLimit.seconds"(val) {
			if (val > 59) {
				this.timeLimit.seconds = 59;
			} else if (val === "00") {
				this.timeLimit.seconds = 0;
			} else if (val === "0" || val === null || val === "") {
				this.timeLimit.seconds = val;
			} else if (val.length > 1) {
				this.timeLimit.seconds = val.replace(/^0+/, "");
			}
		},
		"timeLimit.hours"(val) {
			if (val === "00") {
				this.timeLimit.hours = 0;
			} else if (val === "0" || val === null || val === "") {
				this.timeLimit.hours = val;
			} else if (val.length > 1) {
				this.timeLimit.hours = val.replace(/^0+/, "");
			}
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	computed: {
		validFormCostPerVehicles() {
			return this.propertyCostPerVehicles.length > 0;
		},
		validateForm() {
			return !this.errors.any();
		},
		absoluteDetourLimitTime() {
			return `${
				this.absoluteDetourLimit.hours < 10
					? "0" + this.absoluteDetourLimit.hours
					: this.absoluteDetourLimit.hours
			}:${
				this.absoluteDetourLimit.minutes < 10
					? "0" + this.absoluteDetourLimit.minutes
					: this.absoluteDetourLimit.minutes
			}:${
				this.absoluteDetourLimit.seconds < 10
					? "0" + this.absoluteDetourLimit.seconds
					: this.absoluteDetourLimit.seconds
			}`;
		},
		timeLimitJob() {
			return `${this.timeLimit.hours < 10 ? "0" + this.timeLimit.hours : this.timeLimit.hours}:${
				this.timeLimit.minutes < 10 ? "0" + this.timeLimit.minutes : this.timeLimit.minutes
			}:${this.timeLimit.seconds < 10 ? "0" + this.timeLimit.seconds : this.timeLimit.seconds}`;
		},
		jobList() {
			const jobs = this.$store.state.moduleOptimization.standardInputList["jobs"];
			return jobs === undefined || jobs === "" || jobs === null ? [] : jobs;
		},
	},
	methods: {
		deleteItemCostPerVehicles(indexItem) {
			this.propertiesListCostPerVehicles.splice(indexItem, 1);
		},
		addVehicleArray(data) {
			data.forEach((e) => {
				let found = this.propertiesListCostPerVehicles.find((r) => r.identification === e.identification);
				if (!found) {
					this.propertiesListCostPerVehicles.push({identification: e.identification, cost: e.cost});
				}
			});
		},
		closeSidebarAddJob() {
			this.$emit("closeSidebarEmit");
		},
		validateAmountNumber(event) {
			let regex = /^\d+$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberMinutes(field, event) {
			if (field.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		validateInputNumberSeconds(field, event) {
			if (field.length === 2) {
				event.preventDefault();
				return false;
			}
		},
		isCharNumeric(charStr) {
			return /\d/.test(charStr);
		},
		isKeyPressedNumeric(event) {
			const charStr = event.key;
			return this.isCharNumeric(charStr);
		},
		finishedEditingPressed(event) {
			const key = event.key;
			return key === KEY_ENTER || key === KEY_TAB;
		},
		isBackspace(event) {
			return event.key === KEY_BACKSPACE;
		},
		isLeftOrRight(event) {
			return ["ArrowLeft", "ArrowRight"].indexOf(event.key) > -1;
		},
		onKeyDown(event, val) {
			if (this.isLeftOrRight(event) || this.isBackspace(event)) {
				event.stopPropagation();
				return;
			}
			if (!this.finishedEditingPressed(event) && !this.isKeyPressedNumeric(event)) {
				if (event.preventDefault) event.preventDefault();
			}
		},
		buildPayload() {
			return {
				name: this.job.name,
				pickups: this.$store.state.moduleOptimization.listSelectedPickupJobs.map(
					(identification) => identification
				),
				deliveries: this.$store.state.moduleOptimization.listSelectedDeliveryJobs.map(
					(identification) => identification
				),
				cost_per_vehicles: this.propertiesListCostPerVehicles,
				ignore: false,
				penalty_cost: parseFloat(this.job.penalty_cost),
				pickup_to_delivery_absolute_detour_limit: this.absoluteDetourLimitTime,
				pickup_to_delivery_time_limit: this.timeLimitJob,
				pickup_to_delivery_relative_detour_limit: parseFloat(this.job.pickup_to_delivery_relative_detour_limit),
			};
		},
		createJob() {
			this.$vs.loading();
			this.$validator.validateAll("create-job").then((result) => {
				const countPickupJobs = this.$store.state.moduleOptimization.listSelectedPickupJobs.length;
				const countDeliveryJobs = this.$store.state.moduleOptimization.listSelectedDeliveryJobs.length;
				this.$vs.loading.close();
				if (!result) {
					this.showValidationError();
					return;
				}
				if (countPickupJobs <= 0 || countDeliveryJobs <= 0) {
					this.$vs.notify({
						color: "warning",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("Jobs.ToProceedYouMustAddAtLeast"),
						time: 9000,
					});
					return;
				}
				if (this.jobList.length > 0) {
					let findName = this.jobList.findIndex((elem) => elem.name === this.job.name);
					if (findName != -1) {
						this.$vs.notify({
							color: "danger",
							title: this.$t("VisitPoints.ValidData.Title"),
							text: this.$t("Jobs.ThisJobCannotBeAdded"),
							time: 9000,
						});
						return;
					}
				}
				const payloadStandardInput = this.buildPayload();
				this.$store.commit("moduleOptimization/SET_JOB_STANDARD_INPUT", [payloadStandardInput]);
				this.closeSidebarAddJob();
			});
		},
		showValidationError() {
			this.$vs.notify({
				color: "warning",
				title: this.$t("ErrorFields.Title"),
				text: this.$t("ErrorFields.Text"),
			});
			this.$vs.loading.close();
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleOptimization/REMOVE_ALL_ASSIGNED_PICKUP_JOBS");
		this.$store.commit("moduleOptimization/REMOVE_ALL_ASSIGNED_DELIVERY_JOBS");
	},
};
